module.exports = __webpack_public_path__ + "static/media/fonts-7-mobile.f8770f5f.svg";